import useTranslation from "next-translate/useTranslation";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputTitle, partnershipRequestSchema } from "./helper";
import SelectController from "@components/FormControllers/controllers/SelectController";
import InputController from "@components/FormControllers/controllers/InputController";
import BtnBase from "@components/Buttons/BtnBase";
import { useForm } from "react-hook-form";
import { Text } from "@utils/helper";
import { usePartnerSubmitHandler } from "Hooks/usePartnerSubmitHandler";

export default function PartnershipRequest({ RealEstateOptions }) {
  const { t } = useTranslation("submit-opportunities");
  const { submitHandler, isLoading } = usePartnerSubmitHandler();
  const { control, handleSubmit, setError } = useForm({
    resolver: yupResolver(partnershipRequestSchema),
    defaultValues: {},
  });

  return (
    <form
      className="flex flex-col w-full bg-white relative rounded-[10px] z-10 -top-1 p-3 md:p-10 gap-3 md:gap-10 shadow-[0px_8px_16px_0px_#00000005]"
      onSubmit={handleSubmit(async (values) => {
        await submitHandler(
          values,
          3,
          {
            setError,
          },
          []
        );
      })}
    >
      <div className="flex justify-between gap-6 flex-col md:flex-row">
        <div className="flex w-full flex-col gap-2 sm:gap-4">
          <InputTitle title="PartnershipRequest.company_name" />
          <InputController
            control={control}
            name="company_name"
            className="bg-[#F8FBFF]"
            inputSize="16px"
            placeholder={t("placeholders:company_name")}
          />
        </div>
        <div className="flex w-full flex-col gap-2 sm:gap-4">
          <InputTitle title="PartnershipRequest.full_name" />
          <InputController
            removeNumbers
            control={control}
            name="full_name"
            className="bg-[#F8FBFF]"
            inputSize="16px"
            placeholder={t("placeholders:full_name")}
          />
        </div>
      </div>
      <div className="flex justify-between gap-6 flex-col md:flex-row">
        <div className="flex w-full flex-col gap-2 sm:gap-4">
          <InputTitle title="PartnershipRequest.phone_number" />
          <InputController
            removeText
            control={control}
            name="phone_number"
            className="bg-[#F8FBFF]"
            inputConstrains={{ maxLength: 9 }}
            inputSize="16px"
            placeholder={t("placeholders:phone")}
          />
        </div>
        <div className="flex w-full flex-col gap-2 sm:gap-4">
          <InputTitle title="PartnershipRequest.email" />
          <InputController
            control={control}
            name="email"
            className="bg-[#F8FBFF]"
            removeSpaces
            inputSize="16px"
            placeholder={t("placeholders:email")}
          />
        </div>
      </div>
      <div className="flex w-full flex-col gap-2 sm:gap-4">
        <InputTitle title="PartnershipRequest.message_subject" />
        <SelectController
          placeholder={t("placeholders:select")}
          control={control}
          name="message_subject"
          className="bg-[#F8FBFF]"
          options={RealEstateOptions?.RealEstateMessageSubject}
        />
      </div>
      <div className="flex w-full flex-col gap-2 sm:gap-4">
        <InputTitle title="PartnershipRequest.message_content" />
        <InputController
          control={control}
          name="message_content"
          className="bg-[#F8FBFF]"
          rows={5}
          multiline
          inputSize="16px"
          inputStyles={{ height: "auto !important" }}
          placeholder={t("placeholders:add_answer")}
        />
      </div>
      <div className="p t-2.5">
        <BtnBase
          disabled={isLoading}
          isLoading={isLoading}
          variant="contained"
          type="submit"
          fullWidth
          className="!rounded-3xl !py-3 !capitalize"
        >
          <Text color="white" className="!top-px leading-normal">
            {t("common-locale:actions.submit")}
          </Text>
        </BtnBase>
      </div>
    </form>
  );
}
